<template>
    <div id="contenedor-switch-compartir-documento">
        <v-form v-model="esformularioValido" ref="documentoAplica">
            <v-row justify="center">
                <v-switch
                    v-model="expediente.compartirConSupervisionExterna"
                    @change="guardar"
                    inset>
                </v-switch>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import mixExpedientes from '../mixExpedientes';

export default {
  name: 'SwitchCompartirDocumento',
  mixins: [mixExpedientes],
  props: {
    expedienteDocumentoEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      esformularioValido: false,
      expediente: {
        compartirConSupervisionExterna: this.expedienteDocumentoEditar
          .compartirConSupervisionExterna,
      },
    };
  },
  methods: {
    guardar() {
      // se actualiza el expediente
      this.mixActualizarExpediente();
    },
    cerrar() {},
  },
};
</script>

<style lang="scss" scoped>

</style>
